"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toClass = exports.toClasses = void 0;
var isarray_1 = __importDefault(require("isarray"));
var utils_1 = require("./utils");
var objectToClass = function (originalKeyStore, jsonObj, Clazz, options) {
    var instance = new Clazz();
    originalKeyStore.forEach(function (propertiesOptions, originalKey) {
        var originalValue = jsonObj[originalKey];
        propertiesOptions.forEach(function (storeItemoptions) {
            var key = storeItemoptions.key, beforeDeserializer = storeItemoptions.beforeDeserializer, deserializer = storeItemoptions.deserializer, targetClass = storeItemoptions.targetClass, optional = storeItemoptions.optional, array = storeItemoptions.array, dimension = storeItemoptions.dimension;
            var disallowIgnoreDeserializer = storeItemoptions.disallowIgnoreDeserializer || !options.ignoreDeserializer;
            var disallowIgnoreBeforeDeserializer = storeItemoptions.disallowIgnoreBeforeDeserializer || !options.ignoreBeforeDeserializer;
            var isValueNotExist = options.distinguishNullAndUndefined ? utils_1.isUndefined : utils_1.isNullOrUndefined;
            var value = originalValue;
            if (isValueNotExist(value)) {
                if (!isValueNotExist(storeItemoptions.default)) {
                    instance[key] = storeItemoptions.default;
                    return;
                }
                if (!optional) {
                    throw new Error("Can't map '" + originalKey + "' to " + Clazz.name + "." + key + ", property '" + originalKey + "' not found");
                }
                return;
            }
            value =
                beforeDeserializer && disallowIgnoreBeforeDeserializer
                    ? beforeDeserializer(value, instance, jsonObj, options)
                    : value;
            if (value && targetClass) {
                if (array) {
                    if (dimension === 1) {
                        // eslint-disable-next-line @typescript-eslint/no-use-before-define
                        value = exports.toClasses(value, targetClass, options);
                    }
                    else {
                        // eslint-disable-next-line @typescript-eslint/no-use-before-define
                        value = value.map(function (cur) { return exports.toClasses(cur, targetClass, options); });
                    }
                    instance[key] = value;
                }
                else {
                    // eslint-disable-next-line @typescript-eslint/no-use-before-define
                    value = exports.toClass(value, targetClass, options);
                }
            }
            instance[key] =
                deserializer && disallowIgnoreDeserializer ? deserializer(value, instance, jsonObj, options) : value;
        });
    });
    return instance;
};
exports.toClasses = function (rawJson, Clazz, options) {
    if (options === void 0) { options = {}; }
    if (!isarray_1.default(rawJson)) {
        throw new Error("rawJson " + rawJson + " must be an array");
    }
    var constructor = Clazz.prototype.constructor;
    var originalKetStore = utils_1.getOriginalKetStore(constructor);
    return rawJson.map(function (item) { return objectToClass(originalKetStore, item, constructor, options); });
};
exports.toClass = function (rawJson, Clazz, options) {
    if (options === void 0) { options = {}; }
    var constructor = Clazz.prototype.constructor;
    return objectToClass(utils_1.getOriginalKetStore(constructor), rawJson, constructor, options);
};
//# sourceMappingURL=to-class.js.map